import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import type { BulkUpdates } from '../../../types/bulk';
import { BulkApplyButton, BulkFieldRow, bulkSelectClass } from '../BulkFieldRow';

type AutoExtensionMode = '' | 'enable' | 'disable';

interface BulkAutoExtensionFieldProps {
  onUpdate: (updates: BulkUpdates) => void;
}

export function BulkAutoExtensionField({ onUpdate }: BulkAutoExtensionFieldProps) {
  const [mode, setMode] = useState<AutoExtensionMode>('');
  const [autoExtensionRate, setAutoExtensionRate] = useState(30);
  const [autoExtensionCount, setAutoExtensionCount] = useState(1);

  const handleApply = () => {
    if (mode === 'enable') {
      onUpdate({
        autoExtension: true,
        autoExtensionRate,
        autoExtensionCount
      });
    } else if (mode === 'disable') {
      onUpdate({ autoExtension: false });
    }

    setMode('');
    setAutoExtensionRate(30);
    setAutoExtensionCount(1);
  };

  const rateSelectClass = `${bulkSelectClass} md:w-32`;
  const countSelectClass = `${bulkSelectClass} md:w-24`;

  return (
    <BulkFieldRow
      icon={<RefreshCw className="w-5 h-5 text-gray-500 shrink-0" />}
      label="自動再出品を変更"
    >
      <div className="flex w-full min-w-0 flex-1 flex-col gap-2 md:flex-row md:items-center md:gap-2">
        <select
          value={mode}
          onChange={(e) => setMode(e.target.value as AutoExtensionMode)}
          className={bulkSelectClass}
        >
          <option value="">選択してください</option>
          <option value="enable">有効にする</option>
          <option value="disable">無効にする</option>
        </select>

        {mode === 'enable' && (
          <div className="flex w-full gap-2 md:contents">
            <select
              value={autoExtensionRate}
              onChange={(e) => setAutoExtensionRate(Number(e.target.value))}
              className={rateSelectClass}
              aria-label="値下げ率"
            >
              <option value="0">値下げしない</option>
              <option value="5">5%</option>
              <option value="10">10%</option>
              <option value="15">15%</option>
              <option value="20">20%</option>
              <option value="25">25%</option>
              <option value="30">30%</option>
            </select>
            <select
              value={autoExtensionCount}
              onChange={(e) => setAutoExtensionCount(Number(e.target.value))}
              className={countSelectClass}
              aria-label="再出品回数"
            >
              {[1, 2, 3].map(count => (
                <option key={count} value={count}>{count}回</option>
              ))}
            </select>
          </div>
        )}

        <BulkApplyButton disabled={!mode} onClick={handleApply} />
      </div>
    </BulkFieldRow>
  );
}
